import { Checkbox, FormControlLabel, withStyles, WithStyles, Theme, Grid } from '@material-ui/core'
import i18next from 'i18next'
//import { FC } from 'react'

const styles = (theme: Theme) => ({
  container: {
    boxSizing: 'border-box' as const,
    width: '100%',
    padding: '0px',
    marginTop: '16px',
    background: 'transparent',
  },
  checkboxGrid: {
    width: '100%',
    margin: 0,
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'row' as const,
      flexWrap: 'wrap' as const,
      justifyContent: 'flex-start' as const,
    },
  },
  checkboxItem: {
    [theme.breakpoints.down('xs')]: {
      width: '50%',
      minWidth: 0,
      margin: 0,
      padding: 0,
    },
    width: '20%',
    minWidth: 0,
    margin: 0,
    padding: 0,
  },
})

interface ApplicationsTabsProps extends WithStyles {
  filterState: {
    application: boolean,
    invited: boolean,
    viewingReserved: boolean,
    wantsContract: boolean,
    rejected: boolean
  },
  setFilterState: React.Dispatch<React.SetStateAction<{
    application: boolean,
    invited: boolean,
    viewingReserved: boolean,
    wantsContract: boolean,
    rejected: boolean
  }>>,
  t: i18next.TFunction
  isAdmin: boolean
}

const ApplicationsTabs = ({
  filterState,
  setFilterState,
  t,
  classes,
  isAdmin
}: ApplicationsTabsProps) => {
  // No destructure needed

  return (
    <div className={classes.container}>
      <Grid container spacing={0} className={classes.checkboxGrid}>
        <Grid item className={classes.checkboxItem}>
          <FormControlLabel
            control={
              <Checkbox
                checked={filterState.application}
                onChange={(_, checked) => setFilterState(s => ({ ...s, application: checked }))}
                color="primary"
              />
            }
            label={t('applications.tabs.created', 'Asuntohakemus')}
          />
        </Grid>
        <Grid item className={classes.checkboxItem}>
          <FormControlLabel
            control={
              <Checkbox
                checked={filterState.invited}
                onChange={(_, checked) => setFilterState(s => ({ ...s, invited: checked }))}
                color="primary"
              />
            }
            label={t('applications.tabs.inviteSent', 'Kutsu lähetetty')}
          />
        </Grid>
        <Grid item className={classes.checkboxItem}>
          <FormControlLabel
            control={
              <Checkbox
                checked={filterState.viewingReserved}
                onChange={(_, checked) => setFilterState(s => ({ ...s, viewingReserved: checked }))}
                color="primary"
              />
            }
            label={t('applications.tabs.showingReserved', 'Asuntonäyttö sovittu')}
          />
        </Grid>
        <Grid item className={classes.checkboxItem}>
          <FormControlLabel
            control={
              <Checkbox
                checked={filterState.wantsContract}
                onChange={(_, checked) => setFilterState(s => ({ ...s, wantsContract: checked }))}
                color="primary"
              />
            }
            label={t('applications.tabs.contractPhase', 'Sopimusvaihe')}
          />
        </Grid>
        {
          isAdmin && (
            <Grid item className={classes.checkboxItem}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={filterState.rejected}
                    onChange={(_, checked) => setFilterState(s => ({ ...s, rejected: checked }))}
                    color="primary"
                  />
                }
                label={t('applications.tabs.rejected', 'Ohitetut')}
              />
            </Grid>
          )
        }
      </Grid>
    </div>
  )
}

export default withStyles(styles)(ApplicationsTabs)
